import API from './API.js'

export default class EduContentRoom extends API {
  constructor() {
    super('edu-content-room')
  }
}
